import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import * as api from '../api/endpoints';
import { PageHeader } from '../components/layout/PageHeader';
import { Card, EmptyState, Pill, Skeleton } from '../components/ui/primitives';
import { dateTime } from '../lib/format';

/** Renter-facing notification history: what the system sent about my reservations. */
export function NotificationsPage() {
  const notifications = useQuery({
    queryKey: ['notifications', 'mine'],
    queryFn: () => api.listNotifications({ pageSize: 50 }),
  });

  return (
    <>
      <PageHeader
        title="Notifikace"
        description="Historie zpráv, které půjčovna poslala k tvým rezervacím."
      />

      {notifications.isLoading ? (
        <Skeleton className="h-64" />
      ) : (notifications.data?.items.length ?? 0) === 0 ? (
        <EmptyState
          title="Žádné notifikace"
          description="Zpráva odejde při potvrzení rezervace a při jejím zrušení."
        />
      ) : (
        <ul className="flex flex-col gap-2">
          {notifications.data?.items.map((log) => (
            <li key={log.id}>
              <Card className="flex flex-wrap items-center justify-between gap-3 p-4">
                <div>
                  <p className="text-[13px] font-medium">
                    {log.template === 'reservation-confirmed'
                      ? 'Rezervace potvrzena'
                      : log.template === 'reservation-cancelled'
                        ? 'Rezervace zrušena'
                        : log.template}
                  </p>
                  {log.reservationId !== null && (
                    <Link
                      to={`/reservations/${log.reservationId}`}
                      className="mono text-[11px] text-[var(--accent)] hover:underline"
                    >
                      {log.reservationId.slice(0, 8)}…
                    </Link>
                  )}
                </div>
                <div className="flex items-center gap-2">
                  <Pill tone={log.channel === 'EMAIL' ? 'info' : 'neutral'}>{log.channel}</Pill>
                  <Pill
                    tone={log.status === 'SENT' ? 'accent' : log.status === 'FAILED' ? 'danger' : 'warn'}
                  >
                    {log.status}
                  </Pill>
                  <span className="mono text-[11px] text-[var(--text-muted)]">
                    {dateTime(log.createdAt)}
                  </span>
                </div>
              </Card>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
